export enum PORTAL_ACRONYMS {
    BellesDemeures = 'BD',
    Immonet = 'IMN',
    ImmoWeb = 'IWB',
    ImmoWelt = 'IWT',
    ImmoWeltAu = 'IWTA',
    LaCoteImmo = 'LCI',
    LogicImmo = 'LI',
    LogicImmoConstruire = 'LICONSTRUIRE',
    LogicImmoNeuf = 'LINEUF',
    LuxeResidence = 'LUX',
    MeilleursAgents = 'MA',
    SeLoger = 'SL',
    SeLogerBureauxCommerces = 'SLBC',
    SeLogerConstruire = 'SLC',
    SeLogerNeuf = 'SLN',
}

export enum TRACKING_PORTAL_ACRONYMS {
    BellesDemeures = 'BD',
    Immonet = 'INT', // tracking team acronym
    ImmoWeb = 'IWB',
    ImmoWelt = 'IWT',
    ImmoWeltAu = 'IWTA',
    LaCoteImmo = 'LCI',
    LogicImmo = 'LICOM',
    LogicImmoConstruire = 'LICONSTRUIRE',
    LogicImmoNeuf = 'LINEUF',
    LuxeResidence = 'LUX',
    MeilleursAgents = 'MA',
    SeLoger = 'SL',
    SeLogerBureauxCommerces = 'SLBC',
    SeLogerConstruire = 'SLC',
    SeLogerNeuf = 'SLN',
}
